









































































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import Textarea from '@shared/components/forms/inputs/textarea/textarea.vue';
import { CashMovement } from '@accounting/interfaces/cash-movement';
import EntitySelect from '@shared/components/forms/inputs/entity-select/entity-select.vue';
import Switch from '@shared/components/forms/inputs/switch/switch.vue';
import InputGroup from '@shared/components/forms/inputs/input-group/input-group.vue';

@Component({
  name: 'bc-cash-movements-modal',
  components: {
    'bpc-input-group': InputGroup,
    'bc-textarea': Textarea,
    'bpc-entity-select': EntitySelect,
    'bpc-switch': Switch,
  },
})
export default class CashMovementsModal extends Vue {
  // PROPS
  @Prop({ type: Number, required: true }) readonly posSessionId: number;
  @Prop({ type: Boolean, default: false }) readonly showModal: boolean;
  @Prop({ type: Object, default: null }) readonly cashMovement: CashMovement;
  @Prop({ type: Number, default: null }) readonly cashMovementsDefaultAccountId: number;

  // DATA
  public loading = false;
  public amount = 0;
  public justification = '';
  public selectedAccount = null;
  public cashMovementIn = true;

  closeModal() {
    this.resetValues();
    this.$emit('close-cash-movements-modal');
  }

  resetValues() {
    this.amount = 0;
    this.justification = '';
    this.selectedAccount = null;
    this.cashMovementIn = true;
  }

  postCashMovement() {
    const formIsValid = this.formIsValid();
    if (!formIsValid) {
      this.loading = false;
      return;
    }
    this.loading = true;
    if (this.cashMovement) {
      const path = `${this.$bpcApiRouteHelper.getEntityPath('cash-movements')}/${
        this.cashMovement.id
      }`;
      this.$bpcApi
        .put(path, {
          amount: this.amount,
          justification: this.justification,
          account_id: this.selectedAccount.id,
          type: this.cashMovementIn ? 'cash_in' : 'cash_out',
          pos_session_id: this.posSessionId,
        })
        .subscribe(
          res => {
            this.loading = false;
            this.closeModal();
          },
          error => {
            this.loading = false;
            this.handleError(error);
          },
        );
    } else {
      const path = this.$bpcApiRouteHelper.getEntityPath('cash-movements');
      this.$bpcApi
        .post(path, {
          amount: this.amount,
          justification: this.justification,
          account_id: this.selectedAccount.id,
          type: this.cashMovementIn ? 'cash_in' : 'cash_out',
          pos_session_id: this.posSessionId,
        })
        .subscribe(
          res => {
            this.loading = false;
            this.closeModal();
          },
          error => {
            this.loading = false;
            this.handleError(error);
          },
        );
    }
  }

  formIsValid() {
    if (!this.amount) {
      this.$bpcMessage.showErrorMessage({ text: 'accounting.cash_movement.modal.amount_required' });
      return false;
    } else if (!this.selectedAccount) {
      this.$bpcMessage.showErrorMessage({
        text: 'accounting.cash_movement.modal.account_required',
      });
      return false;
    } else if (!this.justification) {
      this.$bpcMessage.showErrorMessage({
        text: 'accounting.cash_movement.modal.justification_required',
      });
      return false;
    } else if (this.amount <= 0) {
      this.$bpcMessage.showErrorMessage({ text: 'accounting.cash_movement.modal.amount_positive' });
      return false;
    }
    return true;
  }

  handleError(error: any) {
    if (error.response && error.response.data) {
      this.$bpcMessage.showErrorMessage({ text: error.response.data.message });
    } else {
      this.$bpcMessage.showErrorMessage({ text: 'global.error' });
    }
  }

  get titleCashMovementModal() {
    if (this.cashMovement) {
      return this.$t('accounting.edit_cash_movement.modal.title');
    }
    return this.$t('accounting.add_cash_movement.modal.title');
  }

  @Watch('showModal')
  onShowModalChange() {
    if (this.showModal && this.cashMovement) {
      this.justification = this.cashMovement.justification;
      this.amount = this.cashMovement.amount;
      this.selectedAccount = this.cashMovement.account_id;
      this.cashMovementIn = this.cashMovement.type === 'cash_in';
    } else if (this.showModal && this.cashMovementsDefaultAccountId) {
      this.selectedAccount = this.cashMovementsDefaultAccountId;
    } else {
      this.resetValues();
    }
  }
}
